import React from "react";
import { BsCreditCard, BsPerson, BsShieldCheck, BsWallet2, BsCashStack } from "react-icons/bs";
import {
  FiClock,
  FiBarChart2,
  FiUploadCloud,
  FiFileText,
  FiPieChart,
  FiTrendingUp,
  FiSend,
  FiRefreshCw,
  FiUsers,
} from "react-icons/fi";
import * as Icons from "./nav";

export const gridOrderImage = (props) => (
  <div>
    <img className="rounded-xl h-20 md:ml-3" src={props.ProductImage} alt="order-item" />
  </div>
);

export const gridOrderStatus = (props) => (
  <button
    type="button"
    style={{ background: props.StatusBg }}
    className="text-white py-1 px-2 capitalize rounded-2xl text-md"
  >
    {props.Status}
  </button>
);

export const links = [
  {
    title: "Dashboard",
    links: [
      {
        name: "Get Started",
        icon: <img src={Icons.more} alt="Nav Icon" />,
        url: "onboarding/get-started",
      },
      {
        name: "Home",
        icon: <img src={Icons.home} alt="Nav Icon" />,
        url: "home",
      },
    ],
  },

  {
    title: "Setup",
    links: [
      {
        name: "All Enrollments",
        icon: <img src={Icons.coupon} alt="Nav Icon" />,
        url: "enrollments",
      },
      {
        name: "All classes",
        icon: <img src={Icons.userMultiple} alt="Nav Icon" />,
        url: "classes",
      },
      {
        name: "School Bus",
        icon: <img src={Icons.bus} alt="Nav Icon" />,
        url: "transportation",
      },
      {
        name: "Parents Management",
        icon: <img src={Icons.userMultiple} alt="Nav Icon" />,
        url: "discounts",
      },
      /*{
        name: 'Announcements',
        icon: <img src={Icons.notification} alt="Nav Icon" />,
        url: 'announcements',
      },*/
      {
        name: "Result Management",
        icon: <img src={Icons.documentAttachment} alt="Nav Icon" />,
        url: "result-management",
      },
      {
        name: "CBT Exams",
        icon: <img src={Icons.coupon} alt="Nav Icon" />,
        url: "cbt-exams",
      },
    ],
  },

  {
    title: "Student Management",
    links: [
      {
        name: "Student Attendance",
        icon: <img src={Icons.tickDouble} alt="Nav Icon" />,
        url: "management/attendance",
      },
      {
        name: "Gate Monitoring",
        icon: <FiClock className="text-xl text-slate-400" />,
        url: "management/clock-in-out",
      },
    ],
  },

  {
    title: "Staff Management",
    links: [
      {
        name: "Teacher Management",
        icon: <img src={Icons.teacher} alt="Nav Icon" />,
        url: "management/teacher",
      },
      {
        name: "Teacher Attendance",
        icon: <img src={Icons.teacher} alt="Nav Icon" />,
        url: "management/teacher-attendance",
      },
      {
        name: "Admin Management",
        icon: <img src={Icons.teacher} alt="Nav Icon" />,
        url: "management/admin",
      },
      /*{
        name: 'Teacher Attendance',
        icon: <img src={Icons.tickDouble} alt="Nav Icon" />,
        url: 'management/attendance',
      },*/
    ],
  },

  // Money coming in from parents.
  {
    title: "Fees & Invoices",
    links: [
      {
        name: "Student Invoices",
        icon: <img src={Icons.payment} alt="Nav Icon" />,
        url: "class-payments",
      },
      {
        name: "All Payments",
        icon: <img src={Icons.creditCardPos} alt="Nav Icon" />,
        url: "all-payments",
      },
      {
        name: "Extra Fees",
        icon: <img src={Icons.invoice} alt="Nav Icon" />,
        url: "class-addons",
      },
    ],
  },
  /*{
    title: 'KYC',
    links: [
      {
        name: 'Personal',
        icon: <BsFillPersonPlusFill />,
        url: 'compliance/personal',
      },
      {
        name: 'Business',
        icon: <BsFillJournalBookmarkFill />,
        url: 'compliance/business',
      },
      {
        name: 'Payment',
        icon: <FiCreditCard />,
        url: 'compliance/payment',
      },
    ],
  },*/
  // Money the school holds and spends. Ordered by how often it's opened —
  // Funds sits last because it's configuration you set once, not weekly work.
  {
    title: "Finance",
    links: [
      {
        name: "Overview",
        icon: <FiPieChart className="text-xl text-slate-400" />,
        url: "finance/dashboard",
      },
      {
        name: "Expenses",
        icon: <BsCashStack className="text-xl text-slate-400" />,
        url: "finance/expenses",
      },
      {
        name: "Withdraw",
        icon: <img src={Icons.moneyWithdraw} alt="Nav Icon" />,
        url: "withdraw",
      },
      {
        name: "Transfers",
        icon: <FiSend className="text-xl text-slate-400" />,
        url: "finance/transfers",
      },
      {
        name: "Payroll",
        icon: <FiUsers className="text-xl text-slate-400" />,
        url: "finance/payroll/batches",
      },
      {
        name: "Funds",
        icon: <BsWallet2 className="text-xl text-slate-400" />,
        url: "finance/funds",
      },
    ],
  },
  {
    title: "Flexpay",
    links: [
      {
        name: "Flexpay",
        icon: <img src={Icons.invoice} alt="Nav Icon" />,
        url: "flexpay",
      },
      /*{
        name: 'Flexpay Settlement',
        icon: <FaChartBar />,
        url: 'flexpay-history',
      },*/
    ],
  },
  // Periodic and low-frequency: kept out of the daily path above.
  {
    title: "Reports & Compliance",
    links: [
      {
        name: "Reports",
        icon: <FiTrendingUp className="text-xl text-slate-400" />,
        url: "finance/reports",
      },
      {
        name: "Reconciliation",
        icon: <FiRefreshCw className="text-xl text-slate-400" />,
        url: "finance/reconciliation",
      },
      /*{
        name: 'Compliance',
        icon: <BsShieldCheck className="text-xl text-slate-400" />,
        url: 'compliance/business',
      },*/
    ],
  },
  {
    title: "Help",
    links: [
      {
        name: "Support",
        icon: <img src={Icons.messageQuestion} alt="Nav Icon" />,
        url: "support",
      },
    ],
  },
  {
    title: "Personalization",
    links: [
      {
        name: "Billing",
        icon: <BsCreditCard className="text-xl text-slate-400" />,
        url: "billing",
      },
      {
        name: "Settings",
        icon: <img src={Icons.settings} alt="Nav Icon" />,
        url: "settings",
      },
    ],
  },
];

export const linksTeacher = [
  {
    title: "Teacher",
    links: [
      {
        name: "Dashboard",
        icon: <img src={Icons.home} alt="Nav Icon" />,
        url: "teacher",
      },
      {
        name: "Class Management",
        icon: <img src={Icons.userMultiple} alt="Nav Icon" />,
        url: "t/classes",
      },
      {
        name: "Student Attendance",
        icon: <img src={Icons.tickDouble} alt="Nav Icon" />,
        url: "t/attendance",
      },
      {
        name: "Lesson Notes",
        icon: <img src={Icons.documentAttachment} alt="Nav Icon" />,
        url: "t/subjects",
      },
      {
        name: "View Results",
        icon: <FiBarChart2 className="text-xl text-slate-400" />,
        url: "t/results",
      },
      {
        name: "Upload Class Results",
        icon: <FiUploadCloud className="text-xl text-slate-400" />,
        url: "t/upload-class-result",
      },
      {
        name: "Online Test",
        icon: <FiFileText className="text-xl text-slate-400" />,
        url: "t/tests",
      },
      {
        name: "Settings",
        icon: <img src={Icons.settings} alt="Nav Icon" />,
        url: "t/settings",
      },
    ],
  },
];

export const themeColors = [
  {
    name: "blue-theme",
    color: "#1A97F5",
  },
  {
    name: "green-theme",
    color: "#03C9D7",
  },
  {
    name: "purple-theme",
    color: "#7352FF",
  },
  {
    name: "red-theme",
    color: "#FF5C8E",
  },
  {
    name: "indigo-theme",
    color: "#1E4DB7",
  },
  {
    color: "#FB9678",
    name: "orange-theme",
  },
];

export const userProfileData = [
  {
    icon: <BsPerson />,
    title: "My Profile",
    desc: "Account Settings",
    iconColor: "#4543B5",
    iconBg: "rgb(238, 235, 250)",
    link: "/settings",
  },
  {
    icon: <BsShieldCheck />,
    title: "Compliance",
    desc: "KYC & payouts account",
    iconColor: "#4543B5",
    iconBg: "rgb(238, 235, 250)",
    link: "/onboarding/get-started",
  },
  {
    icon: <BsCreditCard />,
    title: "Withdrawal",
    desc: "Fund Withdrawal & Info",
    iconColor: "#4543B5",
    iconBg: "rgb(238, 235, 250)",
    link: "/withdraw",
  },
];

export const teacherProfileData = [
  {
    icon: <BsPerson />,
    title: "My Profile",
    desc: "Account Settings",
    iconColor: "#4543B5",
    iconBg: "rgb(238, 235, 250)",
    link: "/profile",
  },
];
